import { render } from "./404.vue?vue&type=template&id=d9eeb31a"
const script = {}

import "./404.vue?vue&type=style&index=0&id=d9eeb31a&lang=scss"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__